/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
    }

    connectedCallback() {
      this.toggle.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('resize', this.checkVisible.bind(this));


      this.checkVisible();
    }

    checkVisible() {
      if (this.content.offsetHeight > this.max) {
        this.toggle.hidden = false;
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    // Read more and Read less ease the height by the site's rule for opening in place (the
    // --ktechs-open-* values in ktechs-brand.css: the accordion's 250ms and curve), from whatever
    // height is on screen, so a second press mid-way turns it round. It used to jump (merchant,
    // 28 Sep 2026: move like the accordion). Reduced motion changes it at once.
    onClick() {
      const inner = this.querySelector('.max-height--inner');
      const from = inner.getBoundingClientRect().height;
      if (this.motion) this.motion.cancel();
      this.classList.toggle('max-height--enabled');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const to = inner.getBoundingClientRect().height;
      if (Math.abs(to - from) < 1) return;
      const style = getComputedStyle(this);
      const duration = style.getPropertyValue('--ktechs-open-duration').trim();
      // The limit is a max-height, which would clip a shrinking height at once, so the limit
      // itself is what moves.
      this.motion = inner.animate({ maxHeight: [`${from}px`, `${to}px`] }, {
        duration: parseFloat(duration) * (/ms$/.test(duration) ? 1 : 1000) || 250,
        easing: style.getPropertyValue('--ktechs-open-easing').trim() || 'cubic-bezier(0.104, 0.204, 0.492, 1)'
      });
    }
  }
  customElements.define('max-height', MaxHeight);
}
